import { get } from '@/api'

/**
 * Mint a short-lived signed download link for a record. Any record exposing a
 * `download_url` supports this endpoint. Pass `{ preview: true }` to request an
 * inline-renderable link (the download default is an attachment).
 *
 * Returns the full response object — `{ url, filename, content_type, size }`
 * once the backend enriches it; `{ url }` until then. Throws when no URL is
 * returned so callers can handle all failures uniformly.
 */
export async function getSignedDownloadUrl(
  appName,
  modelName,
  id,
  { preview = false } = {},
) {
  const { data } = await get(
    `${appName}/${modelName}/${id}/signed-download-url/`,
    preview ? { params: { preview: 'true' } } : {},
  )
  if (!data?.url) throw new Error('No download URL was returned for this file.')
  return data
}

// `uri` contains the active copy selected by the server.
export async function getDatasetPreviewDatafileCopy(datasetId) {
  const { data } = await get('data_management/datafiles/', {
    params: {
      dataset_id: datasetId,
      fields: 'id,uri,is_dir',
      response_format: 'flat',
      page_size: 2,
    },
  })
  const datafiles = Array.isArray(data) ? data : data?.results || []
  if (datafiles.length !== 1 || datafiles[0].is_dir) return null

  const datafileCopy = datafiles[0].uri
  if (!datafileCopy?.id) return null

  const { data: copyData } = await get(
    `data_management/datafilecopies/${datafileCopy.id}/`,
    {
      params: {
        fields: 'id,contenttype,filesize,status,download_url',
        response_format: 'flat',
      },
    },
  )
  const copyDetails = copyData?.results || copyData
  return copyDetails?.id ? { ...datafileCopy, ...copyDetails } : null
}
